import { AfterViewInit,Component, ElementRef, Input, OnChanges, OnInit } from '@angular/core';

//@classLog
@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.css'],
    standalone: false
})
export class AvatarComponent implements OnInit, AfterViewInit, OnChanges
{
  @Input() fullName: string = ``
  @Input() diameter: number = 23
  @Input() showName: boolean = false
  @Input() fillColor: boolean = false


  initials: string = ``

  constructor(private elementRef: ElementRef) { }


  ngOnChanges(): void
  {
    this.createInitials()
  }


  ngAfterViewInit(): void
  {
    this.elementRef.nativeElement.style.setProperty('--diameter', this.diameter + `px`);
  }


  ngOnInit(): void 
  {
    this.createInitials()
  }


  createInitials(): void 
  {
    let l_parts = this.fullName.split(' ')
    if (l_parts.length > 2) l_parts = l_parts.slice(0, 2)
    let l_res = ''
    l_parts.forEach(l_part =>
    {
      if(l_part) l_res += l_part[0].toUpperCase()
    })

    this.initials = l_res
  }
}